import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import classnames from 'classnames'
import { BOAT_STATUS } from 'types'

const propTypes = {
  status: PropTypes.oneOf(Object.values(BOAT_STATUS)),
}

function BoatStatusBadge({ status }) {
  const isActive = status === BOAT_STATUS.ACTIVE

  return (
    <span
      className={classnames('boat-status-badge', {
        'boat-status-badge-active': isActive,
        'boat-status-badge-inactive': !isActive,
      })}
    >
      {isActive ? BOAT_STATUS.ACTIVE : BOAT_STATUS.INACTIVE}
    </span>
  )
}

BoatStatusBadge.propTypes = exact(propTypes)

export default BoatStatusBadge
